/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/objects'
import * as ActionTypes from '@src/redux/actionTypes/objects.action.types'
import { defaultState, ObjectsState } from './default.state'

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): ObjectsState {
  switch (action.type) {
    case ActionTypes.CHANGE_STATE: {
      const { payload } = action
      return {
        ...state,
        ...payload
      }
    }

    case ActionTypes.SUMMARY_SERVER_ERRORS: {
      const { stateProps = {} as ObjectsState } = action?.payload
      return {
        ...state,
        ...stateProps
      }
    }

    case ActionTypes.GET_OBJECTS_OVERVIEW_STATS_DATA: {
      return {
        ...state,
        objectList: action.payload.list,
        isPending: false
      }
    }

    default: {
      return state
    }
  }
}
